// extracted by mini-css-extract-plugin
module.exports = {"card":"VizBlocksSelect_card__2hG5E","top":"VizBlocksSelect_top__Ya_H2","active":"VizBlocksSelect_active__2u1Oe","icon":"VizBlocksSelect_icon__2vGcL"};